export default __webpack_public_path__ + "static/intro-4e98876d67ec22936addefa33a286bae.mp4";